// components/gallery/GalleryTopics/styles.js
import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const TopicsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: ${props => props.theme.spacing.xl};
    padding: ${props => props.theme.spacing.xl};
`;

export const TopicCard = styled(Link)`
    position: relative;
    border-radius: ${props => props.theme.borderRadius.lg};
    overflow: hidden;
    box-shadow: ${props => props.theme.shadows.md};
    aspect-ratio: 4/3;
    text-decoration: none;
    transition: transform ${props => props.theme.transitions.normal};

    &:hover {
        transform: translateY(-4px);
    }
`;

export const TopicImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export const TopicInfo = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: ${props => props.theme.spacing.lg};
    background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
    color: white;
`;

export const TopicTitle = styled.h3`
    font-size: ${props => props.theme.typography.sizes.xl};
    margin-bottom: ${props => props.theme.spacing.xs};
`;

export const TopicDescription = styled.p`
    font-size: ${props => props.theme.typography.sizes.sm};
    opacity: 0.9;
`;